export type EstadoDaBarra = "expandida" | "recolhida";

const CHAVE = "noesis:barra-lateral";

/**
 * O estado da barra lateral do desktop — expandida ou recolhida.
 *
 * **É escolha do usuário, e só dele.** Nenhuma media query mexe nisto: uma
 * barra que se recolhe sozinha quando a janela encolhe transforma uma
 * preferência em acidente, e o usuário passa a reabri-la toda vez que
 * reposiciona a janela. A largura decide a *forma* da navegação — barra
 * lateral no desktop, faixa inferior no celular —, nunca o estado dela.
 *
 * Mora no `localStorage`, como o tema, e pelo mesmo motivo: é preferência de
 * aparelho, não de conta. O mesmo usuário quer a barra aberta no monitor de
 * 27" e recolhida no notebook, e uma coluna no banco daria a resposta errada
 * num dos dois. O invariante 8 fala de estado do **processo** — sessão, fila,
 * cache —, que é outra coisa.
 *
 * Armazenamento bloqueado não pode impedir o app de abrir: cai no padrão.
 */
export function barraGuardada(): EstadoDaBarra {
  try {
    const v = localStorage.getItem(CHAVE);
    if (v === "expandida" || v === "recolhida") return v;
  } catch {
    /* segue com o padrão */
  }
  return "expandida";
}

export function guardarBarra(estado: EstadoDaBarra): void {
  try {
    localStorage.setItem(CHAVE, estado);
  } catch {
    // Navegador com armazenamento bloqueado ainda precisa exibir o app: a
    // barra funciona na sessão, só não lembra na próxima.
  }
}
